import React, { useEffect, useState } from "react";
import log from "loglevel";
import { isFollowed, updateFollowed } from "components/Profile";
import { recordEvent } from "components/Analytics";
import { useSessionContext } from "components/Session";

const getFollowerCount = (analytics) => {
  log.debug("Analytics", analytics);
  const { Play = 0, Pause = 0, Company = 0, Follow = 0, UnFollow = 0, SeekForward = 0 } = analytics;
  return Follow - UnFollow;
};

const CompanyDetails = (props) => {
  const {
    isApproved,
    optOut,
    exchange,
    symbol,
    companyName,
    event: { year, quarter, conference_date },
    analytics = {},
    earnings,
  } = props;

  const { sessionContext } = useSessionContext();
  const followerCount = getFollowerCount(analytics);

  const [ followed, setFollowed ] = useState(false);

  const onFollowClick = () => {
    log.info("Followed!", exchange, symbol);
    updateFollowed(exchange, symbol, !followed, sessionContext);
    setFollowed(!followed);
    recordEvent({ name: followed ? "UnFollow" : "Follow", exchange, symbol });
  };

  useEffect(() => {
    setFollowed(isFollowed(exchange, symbol));
  }, [setFollowed, exchange, symbol]);

  return (
    <>
      <p className="lbl">Company Details</p>

      <div className="info-block">
        <p className="name">{ companyName }</p>
        <p className="text">
          Followers: <span className="text-primary">{followerCount}</span>
        </p>
        <p className="text">
          Calls: <span className="text-primary">{earnings?.length}</span>
        </p>
      </div>

      <div className="btn-container">
        <button className="btn btn-primary" onClick={onFollowClick}>
          { followed ? "Unfollow" : "Follow" }
        </button>
      </div>
    </>
  );
};

export default CompanyDetails;
